import React from 'react';
import { MapPin } from 'lucide-react';
const cities = ['Buckeye', 'Goodyear', 'Avondale', 'Surprise', 'Peoria', 'Glendale', 'West Phoenix'];
export function ServiceAreas() {
  return <section className="py-24 bg-brand-light relative overflow-hidden" data-id="element-171">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#0B0F19 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-172"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-173">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-orange/10 text-brand-orange rounded-full mb-6" data-id="element-174">
          <MapPin size={32} data-id="element-175" />
        </div>

        <h2 className="text-4xl md:text-5xl font-heading text-brand-dark mb-12" data-id="element-176">
          Now Serving the West Valley
        </h2>

        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto mb-12" data-id="element-177">
          {cities.map((city, index) => <div key={index} className="bg-white border border-gray-200 text-brand-dark px-6 py-3 rounded-full font-medium shadow-sm hover:border-brand-orange hover:text-brand-orange transition-colors cursor-default" data-id="element-178">
              {city}
            </div>)}
        </div>

        <p className="text-brand-gray/70 text-lg" data-id="element-179">
          Don't see your city? Give us a call — we may be able to accommodate
          you.
        </p>
      </div>
    </section>;
}